import React from 'react'
import { CoordinatorListUnderZoneHead } from '../commonfile/CoordinatorListUnderZoneHead'
import useAuthStore from '../../store/useAuthStore'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'

const ZoneHeadCoordinatorList = () => {
    const { user } = useAuthStore()
    return (
        <NormalContainerWithHeader headerText={"Coordinator List"}>
            <CoordinatorListUnderZoneHead id={user?.id} />
        </NormalContainerWithHeader>
    )
}

export default ZoneHeadCoordinatorList